import React, { useEffect, useState } from "react";
import { NavBar, SideBar, Breadcrumb, AddCard } from "../components";
import { handleOnClickLogout } from "../constants";
import { useNavigate } from "react-router-dom";
import "intro.js/introjs.css";
import introJs from "intro.js";

const CreateCard = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const mission = JSON.parse(localStorage.getItem("mission"));
  const token = user.access_token;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [breads, setBreads] = useState(["Cards", "New Cards"]);

  const changeBreadCrumbs = (i) => {
    setBreads(breads.slice(0, i + 1));
  };
  useEffect(() => {
    if (breads.length < 2) {
      navigate("/");
    }
  }, [breads]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (mission && mission.create_card == false) {
      introJs()
        .setOptions({
          steps: [
            {
              title: `Nice to meet you!
Welcome to Nitomeyo`,
              intro:
                "Let’s take a quick tour to help you create and share your first virtual card.",
            },
            {
              title: "Card Preview",
              element: document.querySelector("#businessCard"),
              intro:
                "Here’s how your digital card will look once it’s created.",
            },
            {
              title: "Form Preview",
              element: document.querySelector("#cardForm"),
              intro:
                "Use this form to enrich your card with details. Please complete the required fields that has * on it.",
            },

            {
              title: "Card Configuration",
              element: document.querySelector("#Card"),
              intro:
                "You can configure your card here, like your card's name, your slug url, and your introduction message.",
            },
            {
              title: "Card Configuration",
              element: document.querySelector("#CardName"),
              intro:
                "This is how you can identify your card, the name only visible by you.",
            },
            {
              title: "Card Configuration",
              element: document.querySelector("#CardId"),
              intro:
                "This is how everyone can access your card. So make it as clear as possible. The format url will be app.nitomeyocard/me/your_id. Treat it like your linkedin profile!",
            },
            {
              title: "Display Configuration",
              element: document.querySelector("#Display"),
              intro:
                "Choose your design preferenced, including color, pattern and images you want to include.",
            },
            {
              title: "Personal information",
              element: document.querySelector("#Personal"),
              intro: "Fill in your personal information, and job information.",
            },
            {
              title: "Contact information",
              element: document.querySelector("#Information"),
              intro:
                "Add more channel on how everyone should contact you in social media, mesaging app or business website.",
            },
            {
              title: "Creating card",
              element: document.querySelector("#AddCard"),
              intro: "Click “Add Card” to save and generate your card.",
            },
            {
              title: "Done",
              intro:
                "<img src='https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExcWRmcThrdGg4eTB2Yzk1ZnkzbnI0bTZ5bzdlOTd4b3hwMjFjdWcyZyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/juSCTzqDAV1Xq/giphy.gif' alt='Cat creating card'> This cat understand the tutorial!",
            },
          ],
          showBullets: true,
          tooltipClass: "font-nitomeyocard",
        })
        .start();
    }
  }, []);

  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
        interceptFunc={true}
      />

      <div className="flex flex-row w-full h-full">
        <SideBar active={breads[0].toLocaleLowerCase()} interceptFunc={true} />
        <div className="flex flex-col w-full bg-red-100">
          <Breadcrumb breads={breads} changeBreadCrumbs={changeBreadCrumbs} />
          <div className="flex flex-col w-full h-full justify-center items-center">
            <AddCard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCard;
